import _ from "lodash";
import { useSelector } from "react-redux";
import React, { Fragment, useEffect, useState } from "react";

import AuthAPIs from "./bootstrap/AuthAPIs";
import AppContainer from "./bootstrap/AppContainer";
import { supabase } from "./config/index_supabase";

import "./assets/styles/App.css";
import "./assets/styles/brand-theme.css";

const App = () => {
  const { userSession } = useSelector((state) => state.public);
  const [isActive, setIsActive] = useState(null);
  const [zerodhaAuthNotice, setZerodhaAuthNotice] = useState(null);

  useEffect(() => {
    setIsActive(_.isEmpty(userSession) ? null : userSession);
  }, [userSession]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const requestToken = params.get("request_token");
    const status = params.get("status");

    if (!requestToken || status !== "success") {
      return;
    }

    let cancelled = false;
    const cleanUrl = `${window.location.origin}${window.location.pathname}${window.location.hash || ""}`;
    const showZerodhaAuthError = (message) => {
      setZerodhaAuthNotice({
        type: "error",
        message: message || "Zerodha auth failed. Check the API key and API secret configured in Supabase.",
      });
    };

    const exchangeRequestToken = async () => {
      let exchangeSucceeded = false;

      try {
        let hasSession = false;
        for (let attempt = 0; attempt < 8; attempt += 1) {
          const { data: sessionData } = await supabase.auth.getSession();
          if (sessionData?.session) {
            hasSession = true;
            break;
          }
          await new Promise((resolve) => setTimeout(resolve, 250));
        }

        if (!hasSession) {
          console.error("Zerodha auth callback skipped: active session not found");
          showZerodhaAuthError("Zerodha auth callback skipped because the CandleYogi session was not active.");
          return;
        }

        const { data, error } = await supabase.functions.invoke("zerodha-auth", {
          body: { request_token: requestToken },
        });

        if (error || !data?.connected) {
          console.error("Zerodha auth failed:", error || data);
          showZerodhaAuthError(
            data?.kite_message ||
              data?.details?.message ||
              data?.error ||
              error?.message ||
              "Zerodha auth failed. Check that the frontend API key matches the Supabase API key and secret."
          );
          return;
        }

        exchangeSucceeded = true;
      } catch (err) {
        console.error("Zerodha auth error:", err);
        showZerodhaAuthError(err?.message || "Zerodha auth failed unexpectedly.");
      } finally {
        if (cancelled) return;

        if (exchangeSucceeded) {
          window.location.replace(cleanUrl);
        } else {
          window.history.replaceState({}, document.title, cleanUrl);
        }
      }
    };

    exchangeRequestToken();

    return () => {
      cancelled = true;
    };
  }, []);

  const [loading, setLoading] = useState(true);

  return (
    <Fragment>
      {zerodhaAuthNotice && (
        <div
          role="alert"
          style={{
            position: "fixed",
            top: 16,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            maxWidth: 720,
            width: "calc(100% - 32px)",
            padding: "12px 16px",
            borderRadius: 10,
            background: zerodhaAuthNotice.type === "error" ? "#3b1414" : "#12351f",
            color: "#fff",
            boxShadow: "0 12px 30px rgba(0,0,0,.25)",
            fontWeight: 700,
          }}
        >
          {zerodhaAuthNotice.message}
        </div>
      )}
      <AuthAPIs activeUser={isActive} setLoading={setLoading} />
      {!loading ? <AppContainer /> : <Fragment></Fragment>}
    </Fragment>
  );
};

export default App;
